import React, { useState } from "react";
import * as constant from "../../../utils/constants";
import * as styles from "./FloatingPassword.module.css";
import FloatingInput from "../FloatingInput";

const PASSWORD_REQUIREMENTS = {
  containsLowerCase: "Atleast 1 lowercase letter",
  containsUpperCase: "Atleast 1 uppercase letter",
  containsNumber: "Atleast 1 number",
  containsSpecialCharacter: "Atleast 1 special character",
  containsEightValues: "Atleast 8 characters long",
};

const PASSWORD_REQUIREMENTS_KEYS = Object.keys(PASSWORD_REQUIREMENTS);

const FloatingPassword = React.forwardRef((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const [strongPassword, setStrongPassword] = useState(false);
  const [touched, setTouched] = useState(false);
  const [strongPasswordReq, setStrongPasswordReq] = useState({
    containsUpperCase: false,
    containsLowerCase: false,
    containsNumber: false,
    containsSpecialCharacter: false,
    containsEightValues: false,
  });
  const handleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handlePasswordChange = () => {
    const value = ref?.current?.value || "";
    setTouched(true);

    const checks = {
      containsUpperCase: /[A-Z]/.test(value),
      containsLowerCase: /[a-z]/.test(value),
      containsNumber: /[0-9]/.test(value),
      containsSpecialCharacter: /[^A-Za-z0-9]/.test(value),
      containsEightValues: value.length >= 8,
    };

    setStrongPasswordReq(checks);
    setStrongPassword(!Object.values(checks).includes(false));
  };

  return (
    <div className={styles.password_input_wrapper}>
      <div className={styles.password_input_container}>
        <FloatingInput
          label="Password"
          name="password"
          placeholder=""
          type={showPassword ? "text" : "password"}
          ref={ref}
          className={styles.passwordInput}
          onChange={handlePasswordChange}
          style={touched && !strongPassword ? { border: "1px solid red" } : {}}
        />
        <button
          type="button"
          className={styles.showPassword_btn}
          onClick={handleShowPassword}
        >
          <img
            src={`${constant.IQ_HUB_ASSETS_CDN_BASE_URL}/icons/${
              showPassword ? "eye_hide.svg" : "eye_show.svg"
            }`}
            alt={showPassword ? "passwordOpen" : "passwordHide"}
          />
        </button>
      </div>

      <ul className={styles.password_req_list}>
        {PASSWORD_REQUIREMENTS_KEYS.map((key, index) => (
          <li key={index}>
            <img
              className={`${styles.check_mark} ${
                !strongPasswordReq[key] && styles.required_icon_filter
              }`}
              src={`${constant.IQ_HUB_ASSETS_CDN_BASE_URL}/icons/rounded_check.svg`}
            />
            {PASSWORD_REQUIREMENTS[key]}
          </li>
        ))}
      </ul>
    </div>
  );
});

export default FloatingPassword;
